export enum SectionAccessKeys {
  DASHBOARD = "dashboard",
  DATABASE = "database",
  SYSTEM = "system",
  CRM = "crm",
  FINANCE = "finance",
}

export enum SubSectionAccessKeys {
  TICKET_UPLOAD = "tu",
  TICKET_PROCESSING = "tp",
  TRUCKING_AND_MATERIAL = "tm",
  BID_TOOL_CONFIG = "bt",
  RULE_ENGINE = "ru",
  DOCUMENTS = "doc",
  ROLE_MANAGEMENT = "mr",
}

export enum OperationAccessKeys {
  DATA_INPUT = "di",
  MANAGER_REVIEW = "mr",
  ARCHIVED_VIEW = "av",
  ARCHIVED_EDIT = "ae",
}
